export enum PessoaListaRefinamentoEnum {
    nome = 1,
    email = 2,
    documento = 3,
    telefone = 4,
}